'use client';

import { useMutation } from '@tanstack/react-query';
import { signInOAuth } from '@/lib/api/auth/sign-in-oauth';
import type { OAuthProvider } from '@/lib/schemas/auth/oauth-provider.schema';

type Variables = { provider: OAuthProvider; redirectTo?: string };

export function useSignInOAuth() {
  return useMutation({
    mutationFn: (vars: Variables) => signInOAuth(vars.provider, vars.redirectTo),
  });
}
